import React, { useEffect, useState } from 'react';
import DivLayout from 'components/sales/divLayout/divLayout';
import Layout from 'components/sales/layout/layout';
import localization from "../../../assets/localization/localization";
import { Button } from 'react-bootstrap';
import DocumentView from 'components/sales/downloadDocView/documentView';
import ModifyClaim from "./../unclaimedTransaction/modifyClaim";
import moment from 'moment'

const ViewClaim = ({
  viewClaimDetails,
  viewMaterialDetails,
  match,
  history,
  modificationRequest,
  backToModificationRequest = [],
  documentUploadUrlPublic,
  documentUrlDataPublic
}) => {
  var currentDate = moment('2023-11-29').format('Y-M-D');
  const [isLoading, setIsLoading] = useState(false);
  const [showModifyPopup, setShowModifyPopup] = useState(false);
  const [businessList, setBusinessList] = useState([]);
  const [paymentReference, setPaymentReference] = useState('');
  const [unclaimedId, setUnclaimedId] = useState('');
  const [userId, setUserId] = useState('');
  const [log, setLog] = useState('');

  useEffect(() => {
    (async () => {
      let userDetails = JSON.parse(localStorage.getItem("loginDetails"));
      setUserId(userDetails?.id)
      setIsLoading(true);
      const claimDetails = await viewClaimDetails(match?.params?.pay_ref);
      setPaymentReference(claimDetails?.payment_ref_no);
      setUnclaimedId(claimDetails?.id);
      setIsLoading(false);
    })();
  }, []);

  const handleModificationClick = (val) => {
    setBusinessList(val);
    // Show the ModifyClaim popup
    setShowModifyPopup(true);
  };
  return (
    <Layout title={localization.BacktoList} isGoback={true} isLoading={isLoading}>
      {Object.keys(viewMaterialDetails).length > 0 ? viewMaterialDetails.map((val, index) => {
        return (
          <div className="panel-card card-details" width="100%" key={index}>
            <div className="panel-heading">{localization.claimDetails}</div>
            <div className="panel-body">
              <div className="details-listing detail_alignment">
                {(val.reject_reason !== '' && val.reject_reason !== null && val.reject_reason !== "") &&
                  <div style={{ fontSize: "1.4rem", color: 'red', margin: '0', padding: 0 }} className="col-12">
                    <DivLayout
                      heading={localization.rejectionReason}
                      data={val.reject_reason}
                      headingClass={"unclaimed-reason"}
                    />
                  </div>
                }
                <DivLayout heading={"Payment Reference"} data={val?.payment_ref_no} />
                {val?.status == 'REJECTED' ?
                  <Button className='' variant="primary" onClick={() => handleModificationClick(val)}>
                    Back to modification
                  </Button> :
                  (val?.send_back_modification != null) ?
                    (log != '') ?
                      <Button className='' variant="primary" onClick={() => setLog('')}>
                        {log == val?.id ? 'Hide Logs' : 'View Logs'}
                      </Button> :
                      <Button className='' variant="primary" onClick={() => { setLog(val?.id) }}>
                        View Logs
                      </Button> : ''

                }
                {/*<DivLayout heading={"Business name"} data={val?.client_name} />*/}
                {val?.invoice_data && val?.invoice_data.length > 0 && val?.invoice_data.map((obj, index) => {
                  return (
                    <div className="details-listing" key={index}>
                      <DivLayout
                        heading={localization.invoiceNo}
                        data={obj.invoice_number}
                      />
                      <DivLayout
                        heading={localization.amount}
                        data={obj.amount}
                      />
                      {obj.tds !== undefined &&
                        <DivLayout
                          heading={localization.tdsAmount}
                          data={obj.tds}
                        />
                      }
                    </div>
                  );
                })}
                {val?.payment_proof_doc && val.payment_proof_doc.length > 0 && val.payment_proof_doc.map((obj, index) => {
                  return (
                    <>
                      <DocumentView key={index + 1} title={`${localization.image} ${index + 1}`} attachment={obj} />
                    </>
                  );
                })}

                <DivLayout
                  heading={localization.requestId}
                  data={val.request_id}
                />
                <DivLayout
                  heading={localization.remarks}
                  data={val?.remarks}
                />
                <DivLayout
                  heading={localization.createdBy}
                  data={val?.user_detail?.name}
                />
                <DivLayout
                  heading={localization.status}
                  data={val?.status}
                />
                <DivLayout
                  heading={localization.invoiceNumber}
                  data={val?.invoice_number?.invoice_number}
                />
                <DivLayout
                  heading={localization.amount}
                  data={val?.invoice_number?.amount}
                />
                <DivLayout
                  heading={localization.tdsAmount}
                  data={val?.invoice_number?.tds}
                />

                {log == val?.id && val?.send_back_modification != 'null' && val?.send_back_modification.map(elem => {
                  return (
                    <div className="panel-card card-details" width="100%" key={index}>
                      {/* <div className="panel-heading">{localization.claimDetails + ' ' + localization.history}</div> */}
                      <div className="panel-body">
                        <div className="col-12" style={{ "background-image": "linear-gradient(#99ccff, #ffffff)" }}>
                          <h3 style={{ "fontSize": "15px", "height":"20%" }}>
                            Rejected Claim : {elem.reject_reason.substring(0,50)+'...'}
                          </h3>
                        </div>
                        <div className="details-listing detail_alignment">
                          {(elem.reject_reason !== '' && elem.reject_reason !== null && elem.reject_reason !== "") &&
                            <div style={{ fontSize: "1.4rem", color: 'red', margin: '0', padding: 0 }} className="col-md-12">
                              <DivLayout
                                heading={localization.rejectionReason}
                                data={elem.reject_reason}
                                headingClass={"unclaimed-reason"}
                              />
                            </div>
                          }
                          <DivLayout heading={"Payment Reference"} data={val?.payment_ref_no} />
                          {/*<DivLayout heading={"Business name"} data={val?.client_name} />*/}
                          {elem?.invoice_data && elem?.invoice_data.length > 0 && elem?.invoice_data.map((obj, index) => {
                            return (
                              <div className="details-listing" key={index}>
                                <DivLayout
                                  heading={localization.invoiceNo}
                                  data={obj.invoice_number}
                                />
                                <DivLayout
                                  heading={localization.amount}
                                  data={obj.amount}
                                />
                                {obj.tds !== undefined &&
                                  <DivLayout
                                    heading={localization.tdsAmount}
                                    data={obj.tds}
                                  />
                                }
                              </div>
                            );
                          })}
                          {elem?.payment_proof_doc && elem.payment_proof_doc.length > 0 && elem.payment_proof_doc.map((obj, index) => {
                            return (
                              <>
                                <DocumentView key={index + 1} title={`${localization.image} ${index + 1}`} attachment={obj} />
                              </>
                            );
                          })}

                          <DivLayout
                            heading={localization.requestId}
                            data={elem.request_id}
                          />
                          <DivLayout
                            heading={localization.remarks}
                            data={elem?.remarks}
                          />
                          <DivLayout
                            heading={localization.createdBy}
                            data={elem?.user_detail?.name}
                          />
                          <DivLayout
                            heading={localization.status}
                            data={elem?.status}
                          />
                          <DivLayout
                            heading={localization.invoiceNumber}
                            data={elem?.invoice_number?.invoice_number}
                          />
                          <DivLayout
                            heading={localization.amount}
                            data={elem?.invoice_number?.amount}
                          />
                          <DivLayout
                            heading={localization.tdsAmount}
                            data={elem?.invoice_number?.tds}
                          />

                        </div>
                      </div>
                    </div>
                  )
                })}
                {val?.status == 'REJECTED' && parseInt(userId) === parseInt(val?.created_by) && currentDate <= moment(val?.created_at).format('Y-M-D') && (
                  <div className='col-md-3 mb-5'>
                    <Button className='' variant="primary" onClick={() => handleModificationClick(val)}>
                      Back to modification
                    </Button>
                  </div>
                )}

                <ModifyClaim
                  showModifyPopup={showModifyPopup}
                  onClosePopup={() => setShowModifyPopup(false)}
                  businessList={businessList}
                  paymentReference={val?.payment_ref_no}
                  unclaimedId={match?.params?.id}
                  modificationRequest={modificationRequest}
                  backToModificationRequest={backToModificationRequest}
                  id={index}
                  resetCount={index}
                  isDisable={false}
                />

              </div>
            </div>
          </div>
        );
      }) : <img src="/static/media/noData.970b8ced.png" alt="" width="100%"></img>
      }
    </Layout>
  );
};

export default ViewClaim;
